import { render } from "./CardPicture.vue?vue&type=template&id=5372ee70&scoped=true"
import script from "./CardPicture.vue?vue&type=script&lang=js"
export * from "./CardPicture.vue?vue&type=script&lang=js"

import "./CardPicture.vue?vue&type=style&index=0&id=5372ee70&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5372ee70"]])

export default __exports__